import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import AgreeSelectMain from '../../../../form/fields/AgreeSelectMain'
import { agreeSupplyBillItemNachAPI } from '../../../../../api/supply/supplyBillItemAPI'
import { useDispatch } from 'react-redux'
import { editSupplyBillItem, editSupplyBillsItemsAllItem } from '../../../../../store/supplyBillSlice'
import DisagreeTextMain from '../../../../form/fields/DisagreeTextMain'

const AgreeNachBillItemForm = ({ supplyBillItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(supplyBillItemBd ? {
        isAgreeSupplyLeader: supplyBillItemBd.isAgreeSupplyLeader,
        disagreeSupplyLeaderText: supplyBillItemBd.disagreeSupplyLeaderText
    } : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        agreeSupplyBillItemNachAPI({
            id: supplyBillItemBd.id,
            isAgreeSupplyLeader: data.isAgreeSupplyLeader,
            disagreeSupplyLeaderText: data.disagreeSupplyLeaderText
        }).then(data => {
            if (data) {
                dispatch(editSupplyBillItem(data))
                dispatch(editSupplyBillsItemsAllItem(data))
                // dispatch(editSupplyBillItemIsAgreeSupplyLeader({
                //     id: data.id,
                //     isAgreeSupplyLeader: data.isAgreeSupplyLeader
                // }))
                // dispatch(setSupplyBillsItemsAllIsAgreeSupplyLeader({ // В окремому списку всіх позицій
                //     id: data.id,
                //     isAgreeSupplyLeader: data.isAgreeSupplyLeader
                // }))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження позиції в рахунку начальником постачання
            </p>
        </div>
        {
			formDataProductIsField('agree', 'supplyBillItemAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('agree', 'supplyBillItemAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeSupplyLeader', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeSupplyLeader', e)}
					forciblyValue={
                        data && data.isAgreeSupplyLeader === true ? true :
                        data && data.isAgreeSupplyLeader === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'supplyBillItemAgree') ?
				<DisagreeTextMain
					// required={formDataProductRequiredField('disagreeText', 'supplierAgree')}
					required={
                        data && (data.isAgreeSupplyLeader === false || data.isAgreeSupplyLeader === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'supplyBillItemAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeSupplyLeaderText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeSupplyLeaderText', e)}
					forciblyValue={data ? data.disagreeSupplyLeaderText : ''}
                    className={data && (data.isAgreeSupplyLeader === false || data.isAgreeSupplyLeader === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default AgreeNachBillItemForm